export default "__VITE_ASSET__rZrR1dO0__"